/** @format */

import { Grid, Layout, Skeleton } from 'antd';
import React from 'react';
import { useMaintenanceMessage } from '../../../../shared/maintenance-message';
import { MaintenanceMessage } from '../../../../shared/maintenance-message/maintenance-message';
import { ImpendingMessage } from '../../../../shared/maintenance-message/impending-message';
import {FooterLayout} from './footer-layout'

const { useBreakpoint } = Grid;
const { Content } = Layout;

interface SubPageLayoutProps {
  pageHeader?: JSX.Element;
  fixedHeader?: boolean;
  children?: JSX.Element;
}
/**
 * This is the master layout for the whole application
 * @param props
 * @returns
 */
export const SubPageLayout: React.FC<SubPageLayoutProps> = (props) => {
  const { isImpending, isMaintenance } = useMaintenanceMessage();
  const screens = useBreakpoint();
  return (
    <Layout style={{ minHeight: '100vh', minWidth: "100vw", overflowX: 'clip', display: 'flex', flexDirection: 'column' }}>
      {props.pageHeader && <>{props.pageHeader}</>}

      <Content
        className="site-layout"
        style={{
          padding: screens.lg ? '0 50px' : '0 5px',
          display: 'flex',
          width: '100%'
        }}
      >
        <div
          className="site-layout-background"
          style={{
            paddingLeft: screens.lg ? '40px' : '10px',
            paddingRight: screens.lg ? '40px' : '10px'
          }}
        >
          {isMaintenance === undefined ? (
            <Skeleton />
          ) : isMaintenance ? (
            <MaintenanceMessage />
          ) : isImpending === undefined ? (
            <Skeleton />
          ) : isImpending ? (
            <div>
              <ImpendingMessage />
              {props.children}
            </div>
          ) : (
            props.children
          )}
        </div>
      </Content>

      <FooterLayout />
    </Layout>
  );
};
